import "@/App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import { ChatWidget } from "@/components/landing/ChatWidget";
const Journal = lazy(() => import("@/pages/Journal"));
const Article = lazy(() => import("@/pages/Article"));
const AccountDeletion = lazy(() => import("@/pages/AccountDeletion"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Catalog = lazy(() => import("@/pages/Catalog"));
const SalesKit = lazy(() => import("@/pages/SalesKit"));
const ProfitSheet = lazy(() => import("@/pages/ProfitSheet"));
const RetailerSheets = lazy(() => import("@/pages/RetailerSheets"));
const GetApp = lazy(() => import("@/pages/GetApp"));
const CustomerProfit = lazy(() => import("@/pages/CustomerProfit"));

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen bg-[#f4f1eb]" />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<Article />} />
            <Route path="/account-deletion/:app" element={<AccountDeletion />} />
            <Route path="/privacy/:app" element={<PrivacyPolicy />} />
            <Route path="/terms/:app" element={<Terms />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/sales-kit" element={<SalesKit />} />
            <Route path="/sales-kit/private" element={<ProfitSheet />} />
            <Route path="/sales-kit/retailers" element={<RetailerSheets />} />
            <Route path="/sales-kit/customers" element={<CustomerProfit />} />
            <Route path="/get/:app" element={<GetApp />} />
          </Routes>
        </Suspense>
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
